import React, { useState, useRef, useEffect } from "react";
import { TopButs } from "./TopButs"
import { FormBox } from "./FormBox"
import { MaterialTableBox } from "./materialTableBox"
import { ItemTableBox } from "./itemTableBox"
import { ThreeServiceTable } from "./ThreeServiceTable"
import { ThreeServiceModal } from "./ThreeServiceModal"
import { FixedBottom } from "./FixedBottom"
import { MaterialModal } from "./materialModal"
import { ItemModal } from "./itemModal"
import { SettleDrawer } from "./SettleDrawer"
import useNavModel, { RouterParamType } from "@/model/navModel";
import { IYhFormRef } from "@/components/YhFormBox/Types";
import { useMaintenanceDetailsModel } from "./maintenanceDetailsModels";
import { HistoryModel } from "@/views/historyModel";
import { ConsumeHistoryModel } from "@/views/commonModule/consumeHistoryModel";
import { RepairHistoryModel } from "@/views/commonModule/repairHistoryModel";
import useGlobalModel from "@/model/globalModel";


export const MaintenanceDetails = () => {
    const { getSelectedNavState } = useNavModel();
    const {
        setIsThreeService,
        setHistoryVisible,
        setConsumeHistoryVisible,
        setRepairHistoryVisible,
        setPopupMode,
        setSBcode,
        isThreeService,
        historyVisible,
        historyRow,
        consumeHistoryModel,
        consumeHistoryVisible,
        repairHistoryModel,
        repairHistoryVisible,
        detailLookForm,
        detailAddForm, detailEditForm,
    } = useMaintenanceDetailsModel()
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);
    const IFormRef = useRef<IYhFormRef>();
    const { user: { roles } } = useGlobalModel();

    // 监听工单类型变化
    useEffect(() => {
        const orderType = detailsInfo.mode === "add" ? detailAddForm.orderType : detailsInfo.mode === "edit" ? detailEditForm.orderType : detailLookForm.orderType;
        setIsThreeService(orderType === "maintenanceOrder-type.threeService");
        setPopupMode('')
        setSBcode(null)
    }, [detailsInfo.mode, detailAddForm.orderType, detailEditForm.orderType, detailLookForm.orderType]);

    return (
        <>
            {/* <TopButs {...detailsInfo} /> */}
            <FormBox  {...detailsInfo} IFormRef={IFormRef} />
            {isThreeService ? (
                <ThreeServiceTable {...detailsInfo} IFormRef={IFormRef} />
            ) : (
                <>
                    <ItemTableBox {...detailsInfo} IFormRef={IFormRef} />
                    <MaterialTableBox {...detailsInfo} IFormRef={IFormRef} />
                </>
            )}
            {!roles.includes('hd-b') && <FixedBottom {...detailsInfo} />}
            <MaterialModal {...detailsInfo} />
            <ItemModal {...detailsInfo} />
            <SettleDrawer {...detailsInfo} />
            <ThreeServiceModal {...detailsInfo} IFormRef={IFormRef} />
            <HistoryModel
                visible={historyVisible}
                materialCode={historyRow.materialCode as string}
                materialName={historyRow.materialName as string}
                onCancel={() => setHistoryVisible(false)}
            />
            <ConsumeHistoryModel
                visible={consumeHistoryVisible}
                name={consumeHistoryModel.customerName}
                onCancel={() => setConsumeHistoryVisible(false)}
            />
            <RepairHistoryModel
                visible={repairHistoryVisible}
                licensePlate={repairHistoryModel.licensePlate}
                onCancel={() => setRepairHistoryVisible(false)}
            />
        </>
    )
}